export const STATE_PROP_MACHINE_OVERVIEW = 'machineOverview';
export const CUSTOM_PAGE_SIZE = 5;
